import { updateWebSyncTodo } from '@/api/api'

export default {
  data() {
    return {
      dailyTodoStatusUpdating: false
    }
  },
  methods: {
    hasDailyTodoLevelIcon(level) {
      const value = Number(level)
      return value === 0 || value === 1 || value === 2
    },
    getDailyTodoLevelIcon(item) {
      const level = Number(item && item.level)
      if (!this.hasDailyTodoLevelIcon(level)) {
        return ''
      }
      const prefix = Number(item && item.isFinish) === 1 ? 'todoFinishedLevel' : 'todoUnfinishedLevel'
      return this.paperIcons[`${prefix}${level}`] || ''
    },
    getDailyTodoStatusIcon(item) {
      return Number(item && item.isFinish) === 1
        ? this.paperIcons.todoStatusFinished
        : this.paperIcons.todoStatusUnfinished
    },
    getDailyTodoStatusLabel(item) {
      return Number(item && item.isFinish) === 1 ? '\u6807\u8bb0\u4e3a\u672a\u5b8c\u6210' : '\u6807\u8bb0\u4e3a\u5df2\u5b8c\u6210'
    },
    async toggleDailyTodoStatus(item) {
      if (!item || this.dailyTodoStatusUpdating || this.dailyTodoEditorSubmitting || this.dailyDeleteSubmitting) {
        return
      }
      const id = this.getDailyTodoUpdateId(item)
      const date = item.date
      if (date === undefined || date === null || date === '') {
        this.showDailyTodoStatusFailedMessage(new Error('\u7f3a\u5c11\u66f4\u65b0\u53c2\u6570'))
        return
      }
      const finish = Number(item.isFinish) === 1 ? 0 : 1
      this.dailyTodoStatusUpdating = true
      try {
        const ret = await updateWebSyncTodo({ id, date, finish }, { skipGlobalErrorMessage: true })
        if (!this.isDailyTodoStatusSuccessResponse(ret)) {
          throw ret
        }
        this.applyDailyTodoFinishUpdate(item, finish)
      } catch (error) {
        this.showDailyTodoStatusFailedMessage(error)
      } finally {
        this.dailyTodoStatusUpdating = false
      }
    },
    isDailyTodoStatusSuccessResponse(source) {
      const code = this.getPaperApiCode(source)
      return code === undefined || code === null || code === '' || code == 200 || code == '200'
    },
    applyDailyTodoFinishUpdate(item, finish) {
      const index = this.findDailyRawTodoIndex(item)
      if (index < 0) {
        this.$set(item, 'isFinish', finish)
        return
      }
      const raw = this.dailyRawItems[index]
      if (raw && typeof raw == 'object') {
        this.$set(raw, 'isFinish', finish)
        this.$set(raw, 'finish', finish)
        return
      }
      const next = Object.assign({}, item && item.raw ? item.raw : {}, {
        isFinish: finish,
        finish
      })
      this.$set(this.dailyRawItems, index, next)
    },
    findDailyRawTodoIndex(item) {
      if (!item || !Array.isArray(this.dailyRawItems)) {
        return -1
      }
      const targetId = this.getDailyTodoUpdateId(item)
      for (let i = 0; i < this.dailyRawItems.length; i += 1) {
        const normalized = this.normalizeDailyItem(this.dailyRawItems[i], i)
        if (normalized && normalized.id == item.id) {
          return i
        }
        if (targetId && this.getDailyTodoUpdateId(normalized) == targetId) {
          return i
        }
      }
      return -1
    },
    showDailyTodoStatusFailedMessage(error) {
      if (this.$message && typeof this.$message.error == 'function') {
        this.$message.error(this.getPaperApiErrorMessage(error) || '\u72b6\u6001\u66f4\u65b0\u5931\u8d25')
      }
    }
  }
}
